import { FormInput, PhoneField } from '@/shared/ui/components'
import type { JoinFormValues } from './form-values'

export type EmergencyContactsSectionProps = {
  values: JoinFormValues
  errors: Record<string, string>
  showSecondContact: boolean
  isSubmitting: boolean
  onFieldChange: (field: keyof JoinFormValues, value: string) => void
}

export function EmergencyContactsSection({
  values,
  errors,
  showSecondContact,
  isSubmitting,
  onFieldChange,
}: EmergencyContactsSectionProps) {
  return (
    <div className="flex flex-col gap-6">
      <div className="flex flex-col gap-4">
        <h3 className="text-lg font-medium text-foreground">Primary contact</h3>
        <FormInput
          id="emergencyContact"
          label="Full name"
          required
          value={values.emergencyContact ?? ''}
          onChange={(v) => onFieldChange('emergencyContact', v)}
          error={errors.emergencyContact}
          disabled={isSubmitting}
        />
        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
          <PhoneField
            id="emergencyPhone"
            label="Phone"
            required
            value={values.emergencyPhone ?? ''}
            onChange={(v) => onFieldChange('emergencyPhone', v)}
            error={errors.emergencyPhone}
            disabled={isSubmitting}
          />
          <FormInput
            id="emergencyRelationship"
            label="Relationship"
            value={values.emergencyRelationship ?? ''}
            onChange={(v) => onFieldChange('emergencyRelationship', v)}
            error={errors.emergencyRelationship}
            disabled={isSubmitting}
          />
        </div>
      </div>

      {showSecondContact ? (
        <div className="flex flex-col gap-4">
          <h3 className="text-lg font-medium text-foreground">Secondary contact</h3>
          <FormInput
            id="emergencyContact2"
            label="Full name"
            required
            value={values.emergencyContact2 ?? ''}
            onChange={(v) => onFieldChange('emergencyContact2', v)}
            error={errors.emergencyContact2}
            disabled={isSubmitting}
          />
          <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
            <PhoneField
              id="emergencyPhone2"
              label="Phone"
              required
              value={values.emergencyPhone2 ?? ''}
              onChange={(v) => onFieldChange('emergencyPhone2', v)}
              error={errors.emergencyPhone2}
              disabled={isSubmitting}
            />
            <FormInput
              id="emergencyRelationship2"
              label="Relationship"
              value={values.emergencyRelationship2 ?? ''}
              onChange={(v) => onFieldChange('emergencyRelationship2', v)}
              error={errors.emergencyRelationship2}
              disabled={isSubmitting}
            />
          </div>
        </div>
      ) : null}
    </div>
  )
}
